import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../../axiosinterceptor";

const API = "/auditor_workspace_episode_data";

const initialState = {
  auditorPage: false,
  status: {
    statusChangeLoading: false,
    statusChangeMessage: "",
    statusChangeError: null,
  },
  auditorViewCards:{
     auditorViewCardLoading: false,
    auditorViewCardData: [],
    auditorViewCardError: null,
  },
  auditorViewEpisodesPayload: {
    page_number: 1,
    page_size: 10,
    separation_date_from: null,
    separation_date_to: null,
    admission_date_to: null,
    admission_date_from: null,
    health_fund_contract: [],
    los: [], // Only this array, no los/los_op/los_to
    queue: [],
    speciality: [],
    medical_record_number: [],
    status: [],
    priority: [],
    episode_identifier_search: [],
    // no_mrn: false,
    // no_priority: false,
    // no_los: false,
    los_op: "",
    drg_code: [],
    sort_by: [],
    sort_order: [],
    is_user_specific: true,
    is_global_search:false
  },

  auditorViewStats: {
    auditorViewStatsLoading: false,
    auditorViewStatsData: {},
    auditorViewStatsError: null,
  },
  //side bar queues
  getQueuesData: {
    queuesData: [],
    auditorData :[],
    queuesLoading: false,
    queuesError: null,
    queueMeta: {
      page: 1,
      page_size: 5,
      has_more: false,
    },
    drgInsurers: {}, //  DRG insurers by queue_id
    drgInsurersMeta: {}, //  DRG pagination by queue_id
    loadingMoreQueues: false,
    loadingMoreDRG: false,
    loadingDRGInsurers: {},
  },
  topsectiondetails: {
    topsectionEpisodeDetails: null,
    topsectionEpisodeDetailsLoading: false,
    topsectionEpisodeDetailsError: null,
  },
  bottomsectiondetails: {
    bottomSectionAuditDetails: null,
    bottomSectionAuditDetailsLoading: false,
    bottomSectionAuditDetailsError: null,
  },
  fetchDrgInfo: {
    currentDrgDetails: [],
    currentDrgDetailsLoading: false,
    currentDrgDetailsError: null,
  },
  drgAuditChanges:{
    drgAuditChanges:[],
    drgAuditChangesLoading:false,
    drgAuditChangesError:null
  },
    auditStatusUpdate: {
    loading: false,
    success: false,
    error: null,
    lastUpdatedId: null,
  },
  auditorViewResponse: {
    auditorViewData: [],
    auditorViewDataLoading: false,
    auditorViewDataError: null,
  },
  auditorViewFilters: {
    auditorViewFilterOptionsLoading: false,
    auditorViewFilterOptionsError: null,
    auditorViewFiltersPriority: [],
    auditorViewFiltersStatus: [],
  },
  // speciality: {
  //   specialityPageNumber: 0,
  //   specialityData: [],
  //   specialityLoading: false,
  //   specialityError: null,
  //   isSpecialityPageTrue: true,
  // },
  specialityFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
    forAuditedCount: 0
  },
  episodesURnumber: {
    episodesURnumberPageNumber: 0,
    episodesURnumberData: [],
    episodesURnumberLoading: false,
    episodesURnumberError: null,
    isEpisodesURnumberPageTrue: true,
  },
  queueFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  statusFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  // healthFund: {
  //   healthFundPageNumber: 0,
  //   healthFundData: [],
  //   healthFundLoading: false,
  //   healthFundError: null,
  //   isHealthFundPageTrue: true,
  // },
  losOptions: {
    losPageNumber: 0,
    losData: [], // Array of LOS values like [1, 8, null, 15]
    losLoading: false,
    losError: null,
    isLosPageTrue: true,
  },
  priorityFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  provisionalDrgAuditorOptions: {
    provisionalDrgPageNumber: 0,
    provisionalDrgData: [],
    provisionalDrgLoading: false,
    provisionalDrgError: null,
    isprovisionalDrgPageTrue: true,
  },
  episodeIdsAuditor: {
    episodeIdsAuditorPageNumber: 0,
    episodeIdsAuditorData: [],
    episodeIdsAuditorLoading: false,
    episodeIdsAuditorError: null,
    episodeIdsAuditorPageTrue: true,
    episodeIdsAuditorSearch: "",
  },
  mrn: {
    mrnPageNumber: 0,
    mrnData: [],
    mrnLoading: false,
    mrnError: null,
    isMrnPageTrue: true,
  },
  showAvailableAuditQueues: {
    showAvailableAuditQueuesData: [],
    showAvailableAuditQueuesLoading: false,
    showAvailableAuditQueuesError: null,
  },
};

export const getAuditorViewData = createAsyncThunk(
  "/getAuditorViewData",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API, payload);
      if (response.data) {
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("Error fetching episodes:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
      // throw error;
    }
  },
);

export const getAuditorViewCardData = createAsyncThunk(
  "/getAuditorViewCardData",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/auditor_workspace_cards", payload);
      if (response.data) {
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("Error fetching episodes:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
      // throw error;
    }
  },
);


// export const healthFundOptions = createAsyncThunk(
//   "/healthFundOptions",
//   async (
//     { pageNumber = 1, loadAll = false },
//     { fulfillWithValue, rejectWithValue },
//   ) => {
//     try {
//       const response = await axiosInstance.get(
//         `/San_health_fund_get_filters?page_number=${pageNumber}`,
//       );
//       return fulfillWithValue({
//         data: response.data,
//         pageNumber: pageNumber,
//         loadAll: loadAll,
//       });
//     } catch (error) {
//       console.error("Error fetching health fund options:", error);
//       return rejectWithValue(
//         error.response?.data?.message || error.message || "No data found",
//       );
//     }
//   },
// );
// export const loadAllHealthFunds = createAsyncThunk(
//   "/loadAllHealthFunds",
//   async (_, { dispatch, fulfillWithValue, rejectWithValue }) => {
//     try {
//       let allHealthFunds = [];
//       let currentPage = 1;
//       let hasMore = true;

//       console.log("Starting to load all health funds...");

//       while (hasMore) {
//         console.log(`Loading health funds page ${currentPage}...`);

//         const result = await dispatch(
//           healthFundOptions({
//             pageNumber: currentPage,
//             loadAll: true,
//           }),
//         ).unwrap();

//         // Add data from current page
//         if (result.data?.health_funds) {
//           allHealthFunds = [...allHealthFunds, ...result.data.health_funds];
//         }

//         // Check if there are more pages
//         hasMore = result.data?.has_more || false;

//         // Increment page counter
//         if (hasMore) {
//           currentPage++;
//         }
//       }

//       console.log(
//         `Loaded ${allHealthFunds.length} health funds from ${currentPage} pages`,
//       );

//       return fulfillWithValue({
//         allHealthFunds: allHealthFunds,
//         totalPages: currentPage,
//       });
//     } catch (error) {
//       console.error("Error loading all health funds:", error);
//       return rejectWithValue(
//         error.response?.data?.message ||
//           error.message ||
//           "Failed to load all health funds",
//       );
//     }
//   },
// );



export const getPriorityFilterOptions = createAsyncThunk(
  "/getPriorityFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/auditor_priority_filters_acs",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching priority options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

// Update getAllQueuesData thunk:
export const getAllQueuesData = createAsyncThunk(
  "/getAllQueuesData",
  async (
    { pageNumber = 1, isDRGPage = false, currentQueuePage = 1 },
    { fulfillWithValue, rejectWithValue },
  ) => {
    try {
      let url;

      if (isDRGPage) {
        // For DRG insurers: include current queue page AND drg_page
        url = `/auditor_workspace_queues?page_number=${currentQueuePage}&drg_page=${pageNumber}`;
        console.log(
          `📡 Loading DRG insurers: queue_page=${currentQueuePage}, drg_page=${pageNumber}`,
        );
      } else {
        // For regular queue loading
        url = `/auditor_workspace_queues?page_number=${pageNumber}`;
        console.log(`📡 Loading queues: page=${pageNumber}`);
      }

      const response = await axiosInstance.get(url);
      return fulfillWithValue({
        data: response?.data,
        pageNumber: pageNumber,
        isDRGPage: isDRGPage,
        currentQueuePage: currentQueuePage,
      });
    } catch (error) {
      console.error("Error fetching queues:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const changeStatus = createAsyncThunk(
  "/changeStatus",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    const requiredPaylaod = { ...payload };
    delete requiredPaylaod.auditorPage;
    // console.log(requiredPaylaod, 'requiredPaylaod')
    const url = payload?.auditorPage
      ? "/auditor_screen_status_change"
      : "/coding_screen_status_update_";
    try {
      const response = await axiosInstance.post(url, requiredPaylaod);
      if (response.data) {
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("something went wrong :", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "something went wrong",
      );
      // throw error;
    }
  },
);
export const fetchTopSectionEpisodeDetails = createAsyncThunk(
  "/fetchTopSectionEpisodeDetails",
  async (_, { fulfillWithValue, rejectWithValue }) => {
    const hcp_line_id = sessionStorage.getItem("last_hcp_line_id");

    const url = `/hcp_line_id_findings_api?hcp_line_id=${Number(hcp_line_id)}`;
    try {
      const response = await axiosInstance.get(url);
      if (response.data) {
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("something went wrong :", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "something went wrong",
      );
      // throw error;
    }
  },
);
export const showAvailableAuditQueues = createAsyncThunk(
  "/showAvailableAuditQueues",
  async (payload, { fulfillWithValue, rejectWithValue }) => {

    const {hcp_line_id, screen_type} = payload;

    const url = `/get_episode_queue_user_data?hcp_line_id=${Number(hcp_line_id)}&screen_type=${screen_type}`;
    try {
      const response = await axiosInstance.get(url);
      if (response.data) {
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("something went wrong :", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "something went wrong",
      );
      // throw error;
    }
  },
);
export const fetchBottomSectionAuditDetails = createAsyncThunk(
  "/fetchBottomSectionAuditDetails",
  async (_, { fulfillWithValue, rejectWithValue }) => {
    const hcp_line_id = sessionStorage.getItem("last_hcp_line_id");

  const url = `/get_code_enhance_audit_result?hcp_line_id=${Number(hcp_line_id)}`;
    try{
      const response = await axiosInstance.get(url);
      if (response.data) {
        console.log(response, response.data, "dxfcgbhnjk");

        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("something went wrong :", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "something went wrong",
      );
      // throw error;
    }
  },
);
export const fetchDRGInfoOfEpisode = createAsyncThunk(
  '/fetchDRGInfoOfEpisode',
  async(_, {fulfillWithValue, rejectWithValue}) => {
const hcp_line_id = sessionStorage.getItem('last_hcp_line_id');
  const url =`/get_code_enhance_audit_current_episode_data?hcp_line_id=${hcp_line_id}`;
    try{
      const response = await axiosInstance.get(url);
      if (response.data) {
        console.log(response, response.data, "dxfcgbhnjk");

        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("something went wrong :", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "something went wrong",
      );
      // throw error;
    }
  }
)

export const fetchAuditDrgChanges = createAsyncThunk(
  '/fetchAuditDrgChanges',
  async(_, {fulfillWithValue, rejectWithValue}) => {
const hcp_line_id = sessionStorage.getItem('last_hcp_line_id');
  const url =`/get_code_enhance_audit_changes?hcp_line_id=${hcp_line_id}`;
    try{
      const response = await axiosInstance.get(url);
      if(response.data) {
        console.log(response,response.data,'dxfcgbhnjk');
        
       return fulfillWithValue(response.data)
      }
      // return data; 
    }
    catch(error) {
      console.error('something went wrong :', error);
      return rejectWithValue(error.response?.data?.message || error.message || "something went wrong");
      // throw error;
    }
  }
)
export const sendAuditDrgChanges = createAsyncThunk(
  '/sendAuditDrgChanges',
  async(payload, {fulfillWithValue, rejectWithValue}) => {
  const url ='/post_code_enhance_audit_changes';
    try{
      const response = await axiosInstance.post(url, payload);
      if(response.data) {
        // console.log(response,response.data,'dxfcgbhnjk');
        
       return fulfillWithValue(response.data)
      }
      // return data; 
    }
    catch(error) {
      console.error('something went wrong :', error);
      return rejectWithValue(error.response?.data?.message || error.message || "something went wrong");
      // throw error;
    }
  }
)
// Add this thunk with your other thunks (around line 200-220)
export const updateAuditStatus = createAsyncThunk(
  "/updateAuditStatus",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const url = "/hcp_lines_audit_change";
      const response = await axiosInstance.post(url, payload);
      return fulfillWithValue({
        data: response.data,
        payload: payload, // Include the payload so we can use it in reducer
      });
    } catch (error) {
      console.error("Error updating audit status:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to update audit status",
      );
    }
  },
);


export const getAuditorViewStatsData = createAsyncThunk(
  "/getAuditorViewStatsData",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/auditor_workspace_stats",
        payload,
      );
      if (response.data) {
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("Error fetching stats:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
      // throw error;
    }
  },
);


export const getStatusFilterOptions = createAsyncThunk(
  "/getStatusFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/him_status_filter_acs",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching status options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const getLOSOptions = createAsyncThunk(
  "/getLOSOptions",
  async (pageNumber, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/San_los_get_filters?page_number=${pageNumber}`,
      );
      console.log("los options data", response.data);
      return fulfillWithValue({
        data: response.data,
        pageNumber: pageNumber,
      });
    } catch (error) {
      console.error("Error fetching LOS options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const getSpecialityFilterOptions = createAsyncThunk(
  "/getSpecialityFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/him_speciality_filter_acs",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching specility options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const getQueueFilterOptions = createAsyncThunk(
  "/getQueueFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/auditor_queue_filters_acs",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching queue options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);


// export const URnumberOptions = createAsyncThunk(
//   "/URnumberOptions",
//   async (pageNumber, { fulfillWithValue, rejectWithValue }) => {
//     try {
//       const response = await axiosInstance.get(
//         `/San_medical_record_number_filter?page_number=${pageNumber}`,
//       );

//       return fulfillWithValue({
//         data: response.data,
//         pageNumber: pageNumber,
//       });
//     } catch (error) {
//       console.error("Error fetching filter options:", error);
//       return rejectWithValue(
//         error.response?.data?.message || error.message || "No data found",
//       );
//     }
//   },
// );
// export const getAuditorProvisionalDrgData = createAsyncThunk(
//   "/getAuditorProvisionalDrgData",
//   async (payload, { fulfillWithValue, rejectWithValue }) => {
//     // console.log(payload, 'payload')
//     try {
//       const response = await axiosInstance.post(
//         "/drg_filter_options_acs",
//         payload,
//       );
//       if (response.data) {
//         return fulfillWithValue(response.data);
//       }
//       // return data;
//     } catch (error) {
//       console.error("Error Assigning episodes:", error);
//       return rejectWithValue(
//         error.response?.data || error.message || "No data found",
//       );
//       // throw error;
//     }
//   },
// );
// export const getAuditorEpisodeIdData = createAsyncThunk(
//   "/getAuditorEpisodeIdData",
//   async (payload, { fulfillWithValue, rejectWithValue }) => {
//     // console.log(payload, 'payload')
//     try {
//       const response = await axiosInstance.post(
//         "/episode_identifier_options_acs",
//         payload,
//       );
//       if (response.data) {
//         return fulfillWithValue(response.data);
//       }
//       // return data;
//     } catch (error) {
//       console.error("Error Assigning episodes:", error);
//       return rejectWithValue(
//         error.response?.data || error.message || "No data found",
//       );
//       // throw error;
//     }
//   },
// );
// export const mRnOptions = createAsyncThunk(
//   "/mRnOptions",
//   async (
//     { search = "", page_number = 1, page_size = 10 },
//     { fulfillWithValue, rejectWithValue },
//   ) => {
//     try {
//       const payload = {
//         search,
//         page_number,
//         page_size,
//       };

//       const response = await axiosInstance.post(
//         "/mrn_filter_options_acs",
//         payload,
//       );

//       console.log(response, "response");

//       return fulfillWithValue(response.data);
//     } catch (error) {
//       console.error("Error fetching health fund options:", error);

//       return rejectWithValue(
//         error.response?.data?.message || error.message || "No data found",
//       );
//     }
//   },
// );

const auditorViewSlicer = createSlice({
  name: "auditorView",
  initialState,
  reducers: {
    updateComponentState: (state, action) => {
      state.auditorViewComponentState.selectedRecord = action.payload;
    },
    updateFilters: (state, action) => {
      state.auditorViewEpisodesPayload = {
        ...state.auditorViewEpisodesPayload,
        ...action.payload,
      };
    },
    resetAuditorFilters: (state) => {
      state.auditorViewEpisodesPayload = {
        page_number: 1,
        page_size: 10,
        separation_date_from: null,
        separation_date_to: null,
        admission_date_to: null,
        admission_date_from: null,
        health_fund_contract: [],
        length_of_stay: [], // Only this array, no los/los_op/los_to
        queue: [],
        speciality: [],
        medical_record_number: [], 
        status: [],
        priority: [],
         episode_identifier_search: "",
          is_user_specific: true,
        no_mrn: false,
        no_priority: false,
        no_los: false,
        los_op: null,
        drg_code: [],
        sort_by: [],
        sort_order: [],
      };
    },
    updateAuditorPageNumber: (state, action) => {
      state.auditorViewEpisodesPayload.page_number = action.payload;
    },
    updateAuditorPage: (state, action) => {
      state.auditorPage = action.payload;
    },
    // updateSpecialityPageNumber: (state, action) => {
    //   state.speciality.specialityPageNumber = action.payload;
    // },
    updateQueuePageNumber: (state, action) => {
      state.queue.queuePageNumber = action.payload;
    },
    updateUserPageNumber: (state, action) => {
      state.episodesURnumber.episodesURnumberPageNumber = action.payload;
    },
    setSpecialityFilterSearch: (state, action) => {
          state.specialityFilterOptions.search = action.payload;
        },
    setQueueFilterSearch: (state, action) => {
      state.queueFilterOptions.search = action.payload;
    },
    setStatusFilterSearch: (state, action) => {
      state.statusFilterOptions.search = action.payload;
    },
    setPriorityFilterSearch: (state, action) => {
      state.priorityFilterOptions.search = action.payload;
    },
    updateAuditStatusLocally: (state, action) => {
      const { hcpAuditId, isAudited } = action.payload;

      if (state.topsectiondetails.topsectionEpisodeDetails?.findings) {
        state.topsectiondetails.topsectionEpisodeDetails.findings =
          state.topsectiondetails.topsectionEpisodeDetails.findings.map(
            (item) =>
              item.hcp_audit_id === hcpAuditId
                ? { ...item, is_audited: isAudited }
                : item,
          );
      }
    },
    resetAuditorProvisionalDrg(state) {
      state.provisionalDrgAuditorOptions = {
        provisionalDrgPageNumber: 0,
        provisionalDrgData: [],
        provisionalDrgLoading: false,
        provisionalDrgError: null,
        isprovisionalDrgPageTrue: true,
      };
    },
    resetEpisodeIdsAuditorData(state) {
      state.episodeIdsAuditor = {
        episodeIdsAuditorPageNumber: 0,
        episodeIdsAuditorData: [],
        episodeIdsAuditorLoading: false,
        episodeIdsAuditorError: null,
        episodeIdsAuditorPageTrue: true,
        episodeIdsAuditorSearch: "",
      };
    },
     resetFilteAuditorViewModule(state, action) {
      const key = action.payload;
      state[key].search = "";
      state[key].data = [];
      state[key].pageNumber = 1;
      state[key].hasMore = true;
      state[key].loading = false;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getAuditorViewData.pending, (state) => {
        state.auditorViewResponse.auditorViewDataLoading = true;
        state.auditorViewResponse.auditorViewDataError = null;
      })
      .addCase(getAuditorViewData.fulfilled, (state, action) => {
        state.auditorViewResponse.auditorViewDataLoading = false;
        state.auditorViewResponse.auditorViewData = action.payload;
      })
      .addCase(getAuditorViewData.rejected, (state, action) => {
        state.auditorViewResponse.auditorViewDataLoading = false;
        state.auditorViewResponse.auditorViewDataError = action.payload;
      })

      .addCase(getAuditorViewCardData.pending, (state) => {
        state.auditorViewCards.auditorViewCardLoading = true;
        state.auditorViewCards.auditorViewCardError = null;
      })
      .addCase(getAuditorViewCardData.fulfilled, (state, action) => {
        state.auditorViewCards.auditorViewCardLoading = false;
        state.auditorViewCards.auditorViewCardData = action.payload;
      })
      .addCase(getAuditorViewCardData.rejected, (state, action) => {
        state.auditorViewCards.auditorViewCardLoading = false;
        state.auditorViewCards.auditorViewCardError = action.payload;
      })
      .addCase(getAuditorViewStatsData.pending, (state) => {
        state.auditorViewStats.auditorViewStatsLoading = true;
        state.auditorViewStats.auditorViewStatsError = null;
      })
      .addCase(getAuditorViewStatsData.fulfilled, (state, action) => {
        state.auditorViewStats.auditorViewStatsLoading = false;
        state.auditorViewStats.auditorViewStatsData = action.payload;
      })
      .addCase(getAuditorViewStatsData.rejected, (state, action) => {
        state.auditorViewStats.auditorViewStatsLoading = false;
        state.auditorViewStats.auditorViewStatsError = action.payload;
      })
      //showing available audit queues
      .addCase(showAvailableAuditQueues.pending, (state) => {
        state.showAvailableAuditQueues.showAvailableAuditQueuesLoading = true;
        state.showAvailableAuditQueues.showAvailableAuditQueuesError = null;
      })
      .addCase(showAvailableAuditQueues.fulfilled, (state, action) => {
        state.showAvailableAuditQueues.showAvailableAuditQueuesLoading = false;
        state.showAvailableAuditQueues.showAvailableAuditQueuesData =
          action.payload;
      })
      .addCase(showAvailableAuditQueues.rejected, (state, action) => {
        state.showAvailableAuditQueues.showAvailableAuditQueuesLoading = false;
        state.showAvailableAuditQueues.showAvailableAuditQueuesError =
          action.payload;
      })
      //drg options
      // .addCase(getAuditorProvisionalDrgData.pending, (state) => {
      //   state.provisionalDrgAuditorOptions.provisionalDrgLoading = true;
      //   state.provisionalDrgAuditorOptions.provisionalDrgError = null;
      // })
      // .addCase(getAuditorProvisionalDrgData.fulfilled, (state, action) => {
      //   state.provisionalDrgAuditorOptions.provisionalDrgLoading = false;

      //   const { drg_codes = [], has_more } = action.payload;
      //   const page = action.meta.arg.page_number;

      //   if (page === 1) {
      //     state.provisionalDrgAuditorOptions.provisionalDrgData = drg_codes;
      //   } else {
      //     state.provisionalDrgAuditorOptions.provisionalDrgData.push(
      //       ...drg_codes,
      //     );
      //   }

      //   state.provisionalDrgAuditorOptions.provisionalDrgPageNumber = page;
      //   state.provisionalDrgAuditorOptions.isprovisionalDrgPageTrue = has_more;
      // })
      // .addCase(getAuditorProvisionalDrgData.rejected, (state, action) => {
      //   state.provisionalDrgAuditorOptions.provisionalDrgLoading = false;
      //   state.provisionalDrgAuditorOptions.provisionalDrgError = action.payload;
      // })
      .addCase(getSpecialityFilterOptions.pending, (state) => {
              state.specialityFilterOptions.loading = true;
              state.specialityFilterOptions.error = null;
            })
            .addCase(getSpecialityFilterOptions.fulfilled, (state, action) => {
  state.specialityFilterOptions.loading = false;

  const newData = action.payload?.specialities || [];

  if (action.payload?.page_number === 1) {
    state.specialityFilterOptions.data = newData;
  } else {
    state.specialityFilterOptions.data = [
      ...state.specialityFilterOptions.data,
      ...newData,
    ];
  }

  state.specialityFilterOptions.hasMore = action.payload?.has_more ?? false;
  state.specialityFilterOptions.pageNumber = action.payload?.page_number;
})
            // .addCase(getSpecialityFilterOptions.fulfilled, (state, action) => {
            //   state.specialityFilterOptions.loading = false;
            //   if (action.payload?.speciality?.page_number === 1) {
            //     state.specialityFilterOptions.data =
            //       action.payload?.speciality?.values || [];
            //   } else {
            //     state.specialityFilterOptions.data = [
            //       ...state.specialityFilterOptions.data,
            //       ...(action.payload?.speciality?.values || []),
            //     ];
            //   }
            //   const isValidPage = action.payload?.speciality?.has_more ?? false;
            //   state.specialityFilterOptions.hasMore = isValidPage;
            //   state.specialityFilterOptions.forAuditedCount = action.payload.for_audited;
            //   state.specialityFilterOptions.pageNumber =
            //     action.payload?.speciality?.page_number;
            // })
            .addCase(getSpecialityFilterOptions.rejected, (state, action) => {
              state.specialityFilterOptions.loading = false;
              state.specialityFilterOptions.hasMore = false;
              state.specialityFilterOptions.error = action.payload;
            })
      .addCase(getQueueFilterOptions.pending, (state) => {
        state.queueFilterOptions.loading = true;
        state.queueFilterOptions.error = null;
      })
      .addCase(getQueueFilterOptions.fulfilled, (state, action) => {
        state.queueFilterOptions.loading = false;
        const newQueues = action.payload?.queues?.queues || [];
        if (action.payload.page_number === 1) {
          state.queueFilterOptions.data = newQueues;
        } else {
          state.queueFilterOptions.data = [
            ...state.queueFilterOptions.data,
            ...newQueues,
          ];
        }
        const isValidPage = action.payload?.queues?.has_more ?? false;
        state.queueFilterOptions.hasMore = isValidPage;
        state.queueFilterOptions.pageNumber = action.payload.page_number;
      })
      .addCase(getQueueFilterOptions.rejected, (state, action) => {
        state.queueFilterOptions.loading = false;
        state.queueFilterOptions.hasMore = false;
        state.queueFilterOptions.error = action.payload;
      })
      .addCase(getAllQueuesData.fulfilled, (state, action) => {
        const { data, pageNumber, isDRGPage } = action.payload;

        if (isDRGPage) {
          // DRG insurers pagination
          state.getQueuesData.loadingMoreDRG = false;

          // ✅ SIMPLE LOGIC: If we have insurers data, merge it
          if (data?.insurers && typeof data.insurers === "object") {
            const DRG_QUEUE_ID = 70; // Your DRG queue ID

            // Initialize if not exists
            if (!state.getQueuesData.drgInsurers[DRG_QUEUE_ID]) {
              state.getQueuesData.drgInsurers[DRG_QUEUE_ID] = {};
            }

            // Merge new insurers with existing
            const existingInsurers =
              state.getQueuesData.drgInsurers[DRG_QUEUE_ID];
            const newInsurers = data.insurers;

            // Add new insurers (don't overwrite existing ones)
            Object.keys(newInsurers).forEach((insurerName) => {
              if (!existingInsurers[insurerName]) {
                existingInsurers[insurerName] = newInsurers[insurerName];
              }
            });

            console.log(
              `✅ Merged insurers. Now have ${Object.keys(existingInsurers).length} total`,
            );
          }

          // Update metadata
          if (data?.drg_insurer_meta) {
            const DRG_QUEUE_ID = 70;
            state.getQueuesData.drgInsurersMeta[DRG_QUEUE_ID] = {
              page: pageNumber,
              has_more: data.drg_insurer_meta.has_more || false,
              total_insurer_count:
                data.drg_insurer_meta.total_insurer_count || 0,
            };
          }
        } else {
          // Queue pagination (initial load)
          state.getQueuesData.queuesLoading = false;
          state.getQueuesData.loadingMoreQueues = false;

          if (data?.queues && Array.isArray(data.queues)) {
            if (pageNumber === 1) {
              // Store queues
              state.getQueuesData.queuesData = data.queues;
              state.getQueuesData.auditorData = data.auditor || [];
  

              // Store initial DRG insurers from first page
              const drgQueue = data.queues.find((q) => q.queue_id === 70);
              if (drgQueue?.insurers) {
                const DRG_QUEUE_ID = 70;
                state.getQueuesData.drgInsurers[DRG_QUEUE_ID] = {
                  ...drgQueue.insurers,
                };

                // Store metadata
                if (data?.drg_insurer_meta) {
                  state.getQueuesData.drgInsurersMeta[DRG_QUEUE_ID] = {
                    page: 1,
                    has_more: data.drg_insurer_meta.has_more || false,
                    total_insurer_count:
                      data.drg_insurer_meta.total_insurer_count || 0,
                  };
                }
              }
            }
          }

          if (data?.queue_meta) {
            state.getQueuesData.queueMeta = {
              ...data.queue_meta,
              page: pageNumber,
            };
          }
        }
      })

      // Update getAllQueuesData.pending:
      .addCase(getAllQueuesData.pending, (state, action) => {
        const { pageNumber, isDRGPage } = action.meta.arg;

        if (isDRGPage) {
          state.getQueuesData.loadingMoreDRG = true;
        } else if (pageNumber === 1) {
          state.getQueuesData.queuesLoading = true;
        } else {
          state.getQueuesData.loadingMoreQueues = true;
        }
        state.getQueuesData.queuesError = null;
      })

// Update getAllQueuesData.rejected:
.addCase(getAllQueuesData.rejected, (state, action) => {
  const { pageNumber, isDRGPage } = action.meta.arg;
  
  if (isDRGPage) {
    state.getQueuesData.loadingMoreDRG = false;
  } else if (pageNumber === 1) {
    state.getQueuesData.queuesLoading = false;
  } else {
    state.getQueuesData.loadingMoreQueues = false;
  }
  state.getQueuesData.queuesError = action.payload;
})
// .addCase(getAllQueuesData.pending, (state, action) => {
//   const { pageNumber, isDRGPage } = action.meta.arg;
  
//   if (isDRGPage) {
//     // Loading DRG insurers
//     state.getQueuesData.loadingMoreDRG = true;
//   } else if (pageNumber === 1) {
//     // First page of queues
//     state.getQueuesData.queuesLoading = true;
//   } else {
//     // Loading more queues
//     state.getQueuesData.loadingMoreQueues = true;
//   }
//   state.getQueuesData.queuesError = null;
// })
// .addCase(getAllQueuesData.rejected, (state, action) => {
//   const { pageNumber, isDRGPage } = action.meta.arg;
  
//   if (isDRGPage) {
//     state.getQueuesData.loadingMoreDRG = false;
//   } else if (pageNumber === 1) {
//     state.getQueuesData.queuesLoading = false;
//   } else {
//     state.getQueuesData.loadingMoreQueues = false;
//   }
//   state.getQueuesData.queuesError = action.payload;
// })
  // .addCase(URnumberOptions.pending, (state) => {
  //   state.episodesURnumber.episodesURnumberLoading = true;
  //   state.episodesURnumber.episodesURnumberError = null;
  // }).addCase(URnumberOptions.fulfilled, (state, action) => {
  //   state.episodesURnumber.episodesURnumberLoading= false;
  //   // state.users.usersData = action.payload;
  //   state.episodesURnumber.episodesURnumberData =
  //   action.payload?.medical_record_numbers || [];
  //   const isValidPage = action.payload?.has_more ?? false;
  //   state.episodesURnumber.isEpisodesURnumberPageTrue = isValidPage || false;
  // }).addCase(URnumberOptions.rejected, (state, action) => {
  //   state.episodesURnumber.episodesURnumberLoading = false;
  //   state.episodesURnumber.episodesURnumberError = false;
  //    state.episodesURnumber.episodesURnumberError = null;
  // })
  // In the extraReducers section
// .addCase(URnumberOptions.pending, (state) => {
//   state.episodesURnumber.episodesURnumberLoading = true;
//   state.episodesURnumber.episodesURnumberError = null;
// })
// .addCase(URnumberOptions.fulfilled, (state, action) => {
//   const { data, pageNumber } = action.payload;
  
//   state.episodesURnumber.episodesURnumberLoading = false;
//   state.episodesURnumber.episodesURnumberPageNumber = pageNumber;
  
//   // Merge data if loading more pages
//   if (pageNumber === 1) {
//     state.episodesURnumber.episodesURnumberData = data?.medical_record_numbers || [];
//   } else {
//     state.episodesURnumber.episodesURnumberData = [
//       ...state.episodesURnumber.episodesURnumberData,
//       ...(data?.medical_record_numbers || [])
//     ];
//   }
  
//   state.episodesURnumber.isEpisodesURnumberPageTrue = data?.has_more || false;
// })
// .addCase(URnumberOptions.rejected, (state, action) => {
//   state.episodesURnumber.episodesURnumberLoading = false;
//   state.episodesURnumber.episodesURnumberError = action.payload;
// })
  .addCase(changeStatus.pending, (state) => {
    state.status.statusChangeLoading = true;
    state.status.statusChangeError = null;
  }).addCase(changeStatus.fulfilled, (state,action) => {
    state.status.statusChangeLoading= false;
    state.status.statusChangeMessage = action.payload;
  }).addCase(changeStatus.rejected, (state, action) => {
    state.status.statusChangeLoading = false;
    state.status.statusChangeError = action.payload;
  })
    .addCase(fetchTopSectionEpisodeDetails.pending, (state) => {
    state.topsectiondetails.topsectionEpisodeDetailsLoading = true;
    state.topsectiondetails.topsectionEpisodeDetailsError = null;
  }).addCase(fetchTopSectionEpisodeDetails.fulfilled, (state,action) => {
    state.topsectiondetails.topsectionEpisodeDetailsLoading= false;
    state.topsectiondetails.topsectionEpisodeDetails = action.payload;
  }).addCase(fetchTopSectionEpisodeDetails.rejected, (state, action) => {
    state.topsectiondetails.topsectionEpisodeDetailsLoading = false;
    state.topsectiondetails.topsectionEpisodeDetailsError = action.payload;
  })
  .addCase(fetchBottomSectionAuditDetails.pending, (state) => {
    state.bottomsectiondetails.bottomSectionAuditDetailsLoading = true;
    state.bottomsectiondetails.bottomSectionAuditDetailsError = null;
  }).addCase(fetchBottomSectionAuditDetails.fulfilled, (state,action) => {
    state.bottomsectiondetails.bottomSectionAuditDetailsLoading= false;
    state.bottomsectiondetails.bottomSectionAuditDetails = action.payload;
  }).addCase(fetchBottomSectionAuditDetails.rejected, (state, action) => {
    state.bottomsectiondetails.bottomSectionAuditDetailsLoading = false;
    state.bottomsectiondetails.bottomSectionAuditDetailsError = action.payload;
  })
    .addCase(fetchDRGInfoOfEpisode.pending, (state) => {
    state.fetchDrgInfo.currentDrgDetailsLoading= true;
    state.fetchDrgInfo.currentDrgDetailsError = null;
  }).addCase(fetchDRGInfoOfEpisode.fulfilled, (state, action) => {
  state.fetchDrgInfo.currentDrgDetailsLoading = false;
  // Ensure we store an array
  state.fetchDrgInfo.currentDrgDetails = Array.isArray(action.payload) 
    ? action.payload 
    : [action.payload];
}).addCase(fetchDRGInfoOfEpisode.rejected, (state, action) => {
    state.fetchDrgInfo.currentDrgDetailsLoading= false;
    state.fetchDrgInfo.currentDrgDetailsError = action.payload;
  })
    .addCase(updateAuditStatus.pending, (state) => {
    state.auditStatusUpdate.loading = true;
    state.auditStatusUpdate.success = false;
    state.auditStatusUpdate.error = null;
  })
    .addCase(fetchAuditDrgChanges.pending, (state) => {
    state.drgAuditChanges.drgAuditChangesLoading = true;
    state.drgAuditChanges.drgAuditChangesError = null;
  }).addCase(fetchAuditDrgChanges.fulfilled, (state,action) => {
    state.drgAuditChanges.drgAuditChangesLoading= false;
    state.drgAuditChanges.drgAuditChanges = action.payload;
  }).addCase(fetchAuditDrgChanges.rejected, (state, action) => {
    state.drgAuditChanges.drgAuditChangesLoading = false;
    state.drgAuditChanges.drgAuditChangesError = action.payload;
  })
  .addCase(updateAuditStatus.fulfilled, (state, action) => {
    const { hcp_audit_id, is_audited } = action.payload.payload;
    
    state.auditStatusUpdate.loading = false;
    state.auditStatusUpdate.success = true;
    state.auditStatusUpdate.lastUpdatedId = hcp_audit_id;
    
    // Optimistically update the findings in topsectionEpisodeDetails
    if (state.topsectiondetails.topsectionEpisodeDetails?.findings) {
      state.topsectiondetails.topsectionEpisodeDetails.findings = 
        state.topsectiondetails.topsectionEpisodeDetails.findings.map((item) =>
          item.hcp_audit_id === hcp_audit_id
            ? { ...item, is_audited: is_audited }
            : item
        );
    }
  })
  .addCase(updateAuditStatus.rejected, (state, action) => {
    state.auditStatusUpdate.loading = false;
    state.auditStatusUpdate.success = false;
    state.auditStatusUpdate.error = action.payload;
  })
  // Add this case to your extraReducers
// .addCase(getAuditorViewFiltersData.pending, (state) => {
//   state.auditorViewFiltersData.loading = true;
//   state.auditorViewFiltersData.error = null;
// })
// .addCase(getAuditorViewFiltersData.fulfilled, (state, action) => {
//   state.auditorViewFiltersData.loading = false;
//   state.auditorViewFiltersData.for_audited = action.payload.for_audited || 0;
//   state.auditorViewFiltersData.speciality = action.payload.speciality || {
//     values: [],
//     page_number: 1,
//     page_size: 5,
//     has_more: false
//   };
//   state.auditorViewFiltersData.status = action.payload.status || [];
// })
// .addCase(getAuditorViewFiltersData.rejected, (state, action) => {
//   state.auditorViewFiltersData.loading = false;
//   state.auditorViewFiltersData.error = action.payload;
// })
// Add this to extraReducers builder (around line 280-290)
// .addCase(getAuditorSidePanelData.pending, (state) => {
//   state.auditorSidePanel.loading = true;
//   state.auditorSidePanel.error = null;
// })
// .addCase(getAuditorSidePanelData.fulfilled, (state, action) => {
//   state.auditorSidePanel.loading = false;
  
//   // Store for_audited count
//   state.auditorSidePanel.forAuditedCount = action.payload.for_audited || 0;
  
//   console.log(action.payload,"action payload of auditorsidepanel")
//   // Store speciality data
//   const speciality = action.payload?.speciality || {};
//   const isFirstPage = speciality.page_number === 1;
//   state.auditorSidePanel.specialityOptions = isFirstPage
//     ? speciality.values
//     : [...state.auditorSidePanel.specialityOptions, ...speciality.values];
//   state.auditorSidePanel.specialityPagination = {
//     page_number: speciality.page_number,
//     has_more: speciality.has_more,
//   };

//   // Store status data
//   state.auditorSidePanel.statusOptions = action.payload.status || [];
// })
// .addCase(getAuditorSidePanelData.rejected, (state, action) => {
//   state.auditorSidePanel.loading = false;
//   state.auditorSidePanel.error = action.payload;
// })
.addCase(getStatusFilterOptions.pending, (state) => {
        state.statusFilterOptions.loading = true;
        state.statusFilterOptions.error = null;
      })
      .addCase(getStatusFilterOptions.fulfilled, (state, action) => {
        const options = action.payload;
        state.statusFilterOptions.loading = false;
        if (options?.page_number === 1) {
          state.statusFilterOptions.data = action.payload?.status || [];
        } else {
          state.statusFilterOptions.data = [
            ...state.statusFilterOptions.data,
            ...(action.payload?.status || []),
          ];
        }

        const isValidPage = action.payload?.has_more ?? false;
        state.statusFilterOptions.hasMore = isValidPage;
        state.statusFilterOptions.pageNumber = options?.page_number;
      })
      .addCase(getStatusFilterOptions.rejected, (state, action) => {
        state.statusFilterOptions.loading = false;
        state.statusFilterOptions.hasMore = false;
        state.statusFilterOptions.error = action.payload;
      })
      // .addCase(healthFundOptions.pending, (state) => {
      //   state.healthFund.healthFundLoading = true;
      //   state.healthFund.healthFundError = null;
      // })
      // .addCase(healthFundOptions.rejected, (state, action) => {
      //   state.healthFund.healthFundLoading = false;
      //   state.healthFund.isHealthFundPageTrue = false;
      //   state.healthFund.healthFundError = action.payload;
      // })
      // Add this case in your extraReducers
      // .addCase(loadAllHealthFunds.pending, (state) => {
      //   state.healthFund.healthFundLoading = true;
      //   state.healthFund.healthFundError = null;
      // })
      // .addCase(loadAllHealthFunds.fulfilled, (state, action) => {
      //   state.healthFund.healthFundLoading = false;
      //   state.healthFund.healthFundData = action.payload.allHealthFunds;
      //   state.healthFund.isHealthFundPageTrue = false; // No more pages to load
      //   state.healthFund.healthFundPageNumber = action.payload.totalPages;
      // })
      // .addCase(loadAllHealthFunds.rejected, (state, action) => {
      //   state.healthFund.healthFundLoading = false;
      //   state.healthFund.healthFundError = action.payload;
      //   state.healthFund.isHealthFundPageTrue = false;
      // })

      // Also update the existing healthFundOptions.fulfilled to handle both cases
      // .addCase(healthFundOptions.fulfilled, (state, action) => {
      //   const { data, pageNumber, loadAll } = action.payload;
      //   const newHealthFunds = data?.health_funds || [];

      //   state.healthFund.healthFundLoading = false;

      //   state.healthFund.healthFundPageNumber = pageNumber;

      //   if (pageNumber === 1) {
      //     // Regular first page load
      //     state.healthFund.healthFundData = newHealthFunds;
      //   } else {
      //     // Append data for pagination
      //     const existingValues = new Set(state.healthFund.healthFundData);
      //     const filteredNewFunds = newHealthFunds.filter(
      //       (fund) => !existingValues.has(fund),
      //     );

      //     if (filteredNewFunds.length > 0) {
      //       state.healthFund.healthFundData = [
      //         ...state.healthFund.healthFundData,
      //         ...filteredNewFunds,
      //       ];
      //     }
      //   }

      //   state.healthFund.isHealthFundPageTrue = data?.has_more || false;
      // })
      .addCase(getLOSOptions.pending, (state) => {
        console.log("LOS options loading started");
        state.losOptions.losLoading = true;
        state.losOptions.losError = null;
      })
      .addCase(getLOSOptions.fulfilled, (state, action) => {
        const { data, pageNumber } = action.payload;
        console.log("Los action ", action.payload);

        console.log("LOS options loaded successfully:", {
          page: pageNumber,
          itemsCount: data?.length_of_stay?.length || 0,
          hasMore: data?.has_more || false,
          data: data?.length_of_stay,
        });

        state.losOptions.losLoading = false;
        state.losOptions.losPageNumber = pageNumber;

        // For first page, replace the data
        if (pageNumber === 1) {
          state.losOptions.losData = data?.length_of_stay || [];
        }
        // For subsequent pages, append data
        else {
          state.losOptions.losData = [
            ...state.losOptions.losData,
            ...(data?.length_of_stay || []),
          ];
        }

        // Update pagination flag
        state.losOptions.isLosPageTrue = data?.has_more || false;

        console.log("Updated LOS state:", {
          totalItems: state.losOptions.losData.length,
          hasMore: state.losOptions.isLosPageTrue,
          currentPage: state.losOptions.losPageNumber,
        });
      })
      .addCase(getLOSOptions.rejected, (state, action) => {
        console.error("LOS options loading failed:", action.payload);
        state.losOptions.losLoading = false;
        state.losOptions.losError = action.payload;
        state.losOptions.isLosPageTrue = false;
      })
      .addCase(getPriorityFilterOptions.pending, (state) => {
        state.priorityFilterOptions.loading = true;
        state.priorityFilterOptions.error = null;
      })
      .addCase(getPriorityFilterOptions.fulfilled, (state, action) => {
        const options = action.payload;
        state.priorityFilterOptions.loading = false;
        if (options?.page_number === 1) {
          state.priorityFilterOptions.data = action.payload?.priorities || [];
        } else {
          state.priorityFilterOptions.data = [
            ...state.priorityFilterOptions.data,
            ...(action.payload?.priorities || []),
          ];
        }
        const isValidPage = action.payload?.has_more ?? false;
        state.priorityFilterOptions.hasMore = isValidPage;
        state.priorityFilterOptions.pageNumber = action.payload?.page_number;
      })
      .addCase(getPriorityFilterOptions.rejected, (state, action) => {
        state.priorityFilterOptions.loading = false;
        state.priorityFilterOptions.hasMore = false;
        state.priorityFilterOptions.error = action.payload;
      })
      //episode ID's
      // .addCase(getAuditorEpisodeIdData.pending, (state) => {
      //   state.episodeIdsAuditor.episodeIdsAuditorLoading = true;
      //   state.episodeIdsAuditor.episodeIdsAuditorError = null;
      // })
      // .addCase(getAuditorEpisodeIdData.fulfilled, (state, action) => {
      //   state.episodeIdsAuditor.episodeIdsAuditorLoading = false;

      //   const { episode_identifier_number = [], has_more } = action.payload;
      //   const page = action.meta.arg.page_number;

      //   if (page === 1) {
      //     state.episodeIdsAuditor.episodeIdsAuditorData =
      //       episode_identifier_number;
      //   } else {
      //     const existing = new Set(
      //       state.episodeIdsAuditor.episodeIdsAuditorData,
      //     );
      //     const uniqueNew = episode_identifier_number.filter(
      //       (code) => !existing.has(code),
      //     );
      //     state.episodeIdsAuditor.episodeIdsAuditorData.push(...uniqueNew);
      //   }

      //   state.episodeIdsAuditor.episodeIdsAuditorPageNumber = page;
      //   state.episodeIdsAuditor.episodeIdsAuditorPageTrue = has_more;
      // })
      // .addCase(getAuditorEpisodeIdData.rejected, (state, action) => {
      //   state.episodeIdsAuditor.episodeIdsAuditorLoading = false;
      //   state.episodeIdsAuditor.episodeIdsAuditorError = action.payload;
      // })
      // mrn add case

      // .addCase(mRnOptions.pending, (state) => {
      //   state.mrn.mrnLoading = true;
      //   state.mrn.mrnError = null;
      // })
      // .addCase(mRnOptions.fulfilled, (state, action) => {
      //   state.mrn.mrnLoading = false;

      //   const newMrns = action.payload?.medical_record_number || [];

      //   if (action.meta.arg.page_number === 1) {
      //     state.mrn.mrnData = newMrns;
      //   } else {
      //     state.mrn.mrnData = [...state.mrn.mrnData, ...newMrns];
      //   }

      //   state.mrn.isMrnPageTrue = action.payload?.has_more ?? false;
      //   state.mrn.mrnPageNumber =
      //     action.payload?.page_number ?? action.meta.arg.page_number;
      // })

      // .addCase(mRnOptions.rejected, (state, action) => {
      //   state.mrn.mrnLoading = false;
      //   state.mrn.isMrnPageTrue = false;
      //   state.mrn.mrnError = action.payload;
      // }),
});

export const {
  updateAuditorViewFiltersData,
  resetAuditorFilters,
  updateFilters,
  // updateSpecialityPageNumber,
  updateQueuePageNumber,
  updateUserPageNumber,
  updateComponentState,
  updateAuditorPage,
  updateAuditorPageNumber,
  updateAuditStatusLocally,
  resetAuditorProvisionalDrg,
  resetEpisodeIdsAuditorData,
  resetFilteAuditorViewModule,
  setQueueFilterSearch,
  setSpecialityFilterSearch,
  setStatusFilterSearch,
  setPriorityFilterSearch,
} = auditorViewSlicer.actions;

export default auditorViewSlicer.reducer;
